export default __webpack_public_path__ + "static/media/javascripting.b36c2d26.webp";